import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-active-order',
  templateUrl: './edit-active-order.component.html',
  styleUrls: ['./edit-active-order.component.css']
})
export class EditActiveOrderComponent implements OnInit {

editOrderForm : FormGroup = this.fb.group({
  comercio: ['', Validators.required],
  telefono: ['', Validators.required],
  usuario: ['', Validators.required],
  direccion: ['', Validators.required],
  articulo: ['', Validators.required],
  unidad: ['', Validators.required],
  cantidad: ['', Validators.required],
})
  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
  }

}
